import React from 'react';
import { API_BASE_URL } from '../../helpers/ApiSettings';

const LoisirProductTable = ({ products, onEdit, onDelete }) => {
  return (
    <div className="table-responsive">
      <table className="table">
        <thead>
          <tr>
            <th>Image</th>
            <th>Référence</th>
            <th>Titre</th>
            <th>Quantité</th>
            <th>Âge minimum</th>
            <th>Statut</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {products.map((product) => (
            <tr key={product.id}>
              <td>
                {product.images && product.images[0] ? (
                  <img 
                    src={`${API_BASE_URL}${product.images[0].url}`}
                    alt={product.title}
                    style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                  />
                ) : (
                  <div 
                    className="bg-secondary"
                    style={{ width: '50px', height: '50px' }}
                  ></div>
                )}
              </td>
              <td>{product.reference}</td>
              <td>{product.title}</td>
              <td>{product.quanity || 1}</td>
              <td>{product.minimumAge}</td>
              <td>
                <span className={`badge bg-${product.available ? 'success' : 'danger'}`}>
                  {product.available ? 'Disponible' : 'Indisponible'}
                </span>
              </td>
              <td>
                <div className="btn-group">
                  <button
                    className="btn btn-sm btn-info me-2"
                    onClick={() => onEdit(product)}
                    data-bs-toggle="modal"
                    data-bs-target="#editLoisirProductModal"
                  >
                    Modifier
                  </button>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => onDelete(product.documentId)}
                  >
                    Supprimer
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LoisirProductTable;